import type { Agenda } from "@repo/types";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { AgendaTemplateCopyForm } from "./AgendaTemplateCopyForm";
import { AGENDA_MOTIF } from "@/lib/constants";

export const AgendaTemplateCopyDialog = ({
  tenantId,
  template,
  open: outerOpen,
  setOpen: outerSetOpen,
}: {
  tenantId: string;
  template: Agenda;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={AGENDA_MOTIF}>
          <DialogTitle>Select team</DialogTitle>
        </DialogHeader>
        <AgendaTemplateCopyForm
          tenantId={tenantId}
          template={template}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
